import createTheme from './createTheme';
var defaultTheme = createTheme();
export default defaultTheme;


// WEBPACK FOOTER //
// ./node_modules/@material-ui/core/esm/styles/defaultTheme.js